import { styled } from '@nextiva/next-ui-components';
import { PRESENCE_TYPE } from '../../constants';

export const PresenceIndicator = styled('div', {
  shouldForwardProp: (prop) => prop !== 'type',
  name: 'PresenceIndicator',
  slot: 'Root',
})(({ theme, type }) => {
  let styles = null;

  if (type === PRESENCE_TYPE.ONLINE) {
    styles = {
      borderColor: theme.palette.teal.A300,
      backgroundColor: theme.palette.teal.A300,
    };
  } else if (type === PRESENCE_TYPE.BUSY) {
    styles = {
      borderColor: theme.palette.error.main,
      backgroundColor: theme.palette.error.main,
    };
  } else if (type === PRESENCE_TYPE.AWAY) {
    styles = {
      borderColor: theme.palette.warning.main,
      backgroundColor: theme.palette.warning.main,
    };
  } else {
    styles = {
      borderColor: theme.palette.blueGrey.A300,
      backgroundColor: theme.palette.blueGrey.A300,
    };
  }

  return {
    padding: 0,
    marginRight: 8,
    height: 10,
    width: 10,
    borderStyle: 'solid',
    borderWidth: 4,
    borderRadius: '50%',
    boxSizing: 'border-box',
    ...styles,
  };
});